"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSlotVNs = getSlotVNs;
var _xeUtils = _interopRequireDefault(require("xe-utils"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function getSlotVNs(vns) {
  if (_xeUtils["default"].isArray(vns)) {
    return vns;
  }
  return [vns];
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vxe-table/lib/tools/vn.js
// module id = 6b1g
// module chunks = 17